import { NgModule } from '@angular/core';

import { ComponentClassesPipe } from './pipes/component-classes.pipe';
import { ComponentCtaLinkPipe } from './pipes/component-cta-link.pipe';

import { UiCardComponent } from '../cms/components/ui-card/ui-card.component';
import { UiContainerComponent } from '../cms/components/ui-container/ui-container.component';
import { UiFooterComponent } from '../cms/components/ui-footer/ui-footer.component';
import { UiGridComponent } from '../cms/components/ui-grid/ui-grid.component';
import { UiHeaderComponent } from '../cms/components/ui-header/ui-header.component';
import { UiPostComponent } from '../cms/components/ui-post/ui-post.component';
import { UiSliderComponent } from '../cms/components/ui-slider/ui-slider.component';
import { CsStaticComponent } from './components/cs-static/cs-static.component';
import { CPageComponent } from './components/c-page/c-page.component';

import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';




@NgModule({
  declarations: [
    ComponentClassesPipe,
    ComponentCtaLinkPipe,
    CPageComponent,
    CsStaticComponent,
    UiSliderComponent,
    UiGridComponent,
    UiCardComponent,
    UiPostComponent,
    UiContainerComponent,
    UiHeaderComponent,
    UiFooterComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    CPageComponent,
    CsStaticComponent,
    UiSliderComponent,
    UiGridComponent,
    UiCardComponent,
    UiPostComponent,
    UiContainerComponent,
    UiHeaderComponent,
    UiFooterComponent

  ]
})
export class CmsModule { }
